export default "__VITE_ASSET__BcAGJML9__"